export default __webpack_public_path__ + "static/doctor-in-laptop-df1bb5c1ae6939698cfe2cbcdbd87ad9.png";